import React, { useCallback, useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { PopoverMenu, useEscapeKey, useOutsideClick } from '@spark';

const VIEWPORT_PAD = 8;

/**
 * Spark PopoverMenu pinned to a cursor point (cards-view right-click).
 */
export const CardContextMenu = ({ x, y, items = [], onClose }) => {
    const wrapRef = useRef(null);
    const close = useCallback(() => onClose?.(), [onClose]);

    useOutsideClick(wrapRef, close, true);
    useEscapeKey(close, true);

    useLayoutEffect(() => {
        const node = wrapRef.current;
        if (!node) return;
        const box = node.getBoundingClientRect();
        let left = x;
        let top = y;
        if (box.right > window.innerWidth - VIEWPORT_PAD) {
            left = Math.max(VIEWPORT_PAD, window.innerWidth - box.width - VIEWPORT_PAD);
        }
        if (box.bottom > window.innerHeight - VIEWPORT_PAD) {
            top = Math.max(VIEWPORT_PAD, window.innerHeight - box.height - VIEWPORT_PAD);
        }
        node.style.left = `${left}px`;
        node.style.top = `${top}px`;
    }, [x, y]);

    const menuItems = items.map((item) => ({
        label: item.label,
        disableWhenReadOnly: item.disableWhenReadOnly,
        onClick: () => {
            close();
            item.onClick?.();
        },
    }));

    return createPortal(
        <div
            ref={wrapRef}
            className="home-page-card-context-menu"
            style={{ left: x, top: y }}
            onContextMenu={(event) => event.preventDefault()}
        >
            <PopoverMenu tip={false} items={menuItems} />
        </div>,
        document.body
    );
};

export default CardContextMenu;
